// src/admin/hooks/useKonuAtama.ts
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { KayitliSecim, AtanmisKonu } from '@/types';

export interface Department {
  id: number;
  bolum_adi: string;
  firma_adi?: string | null;
  raporlama_yili?: number | null;
  created_at?: string;
}
import { toast } from 'react-hot-toast';

// EN ÖNEMLİ KISIM: 'export' anahtar kelimesi burada olmalı.
export function useKonuAtama(firmaAdi: string | null, raporYili: number | null) {
  const [atanmamisKonular, setAtanmamisKonular] = useState<KayitliSecim[]>([]);
  const [atanmisKonular, setAtanmisKonular] = useState<AtanmisKonu[]>([]);
  const [bolumler, setBolumler] = useState<(Department & { firma_adi?: string; raporlama_yili?: number })[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    if (!firmaAdi || !raporYili) {
      setAtanmamisKonular([]); setAtanmisKonular([]); setBolumler([]);
      return;
    }
    setIsLoading(true); setError(null);
    try {
      // Konu atama verilerini al
      const { data, error: rpcError } = await supabase.rpc('get_konu_atama_data', {
        p_firma_adi: firmaAdi, p_rapor_yili: raporYili,
      });
      if (rpcError) throw rpcError;
      setAtanmamisKonular(data.atanmamisKonular || []);
      setAtanmisKonular(data.atanmisKonular || []);
      
      // Bölümleri ayrı olarak al (genel + firmaya özel)
      const { data: bolumlerData, error: bolumlerError } = await supabase
        .from('bolumler')
        .select('id, bolum_adi, firma_adi, raporlama_yili')
        .or(`firma_adi.is.null,and(firma_adi.eq.${firmaAdi},raporlama_yili.eq.${raporYili})`)
        .order('bolum_adi');
      
      if (bolumlerError) throw bolumlerError;
      setBolumler(bolumlerData || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, [firmaAdi, raporYili]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const assignKonularToBolum = async (konuIdleri: number[], bolumId: number) => {
    const { error } = await supabase.rpc('assign_konular_and_populate_data', {
        p_konu_idler: konuIdleri,
        p_bolum_id: bolumId
    });
    if (error) throw error;
    await fetchData();
  };

  const unassignKonu = async (konu: AtanmisKonu) => {
    const { error } = await supabase.from('secilen_konu').update({ sorumlu_bolum_id: null }).eq('id', konu.id);
    if (error) {
      toast.error(`Atama geri alınamadı: ${error.message}`);
      throw error;
    }
    toast.success(`"${konu.konu}" ataması geri alındı.`);
    await fetchData();
  };

  return { atanmamisKonular, atanmisKonular, bolumler, isLoading, error, assignKonularToBolum, unassignKonu, refetchData: fetchData };
}
